export default __webpack_public_path__ + "static/media/Vazir-Black.9aa8433a.woff2";